export default __webpack_public_path__ + "static/strapi-3c6be016f44f1c7f33a46dd5550eb172.svg";